/**
 * collection-filters.js
 * Progressive enhancement for #FacetFiltersForm in
 * sections/collection-product-grid.liquid: auto-submits when a
 * filter checkbox changes (instead of requiring "Apply") and
 * closes the mobile filter drawer on outside click / Escape.
 */
(function () {
  var form = document.getElementById('FacetFiltersForm');
  var filterPanel = document.getElementById('CollectionFilters');
  var filterToggle = document.getElementById('CollectionFilterToggle');

  if (form) {
    var inputs = form.querySelectorAll('input[type="checkbox"]');
    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        form.submit();
      });
    });
  }

  if (filterPanel) {
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && filterPanel.classList.contains('is-open')) {
        filterPanel.classList.remove('is-open');
        document.body.classList.remove('collection-filters-open');
        if (filterToggle) {
          filterToggle.setAttribute('aria-expanded', 'false');
          filterToggle.focus();
        }
      }
    });
  }
})();
